// frontend/src/admin/blockforms/blockSaveTarget.js
// Single source of truth for WHERE a block form saves, for both teaching and QA.
// Teaching levels -> /rich-content with a card parent.
// QA (level === 'qa') -> /predefined-qa-rich-content with qa_id + section.

const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8001';

export function buildBlockSave({ level, entityId, section, editingBlock, blockType, contentData, orderIndex }) {
    const isQA = level === 'qa';
    const base = isQA ? `${API_BASE}/predefined-qa-rich-content` : `${API_BASE}/rich-content`;

    // QA rows use qa_content_id as PK; teaching rows use rich_content_id.
    const blockId = editingBlock
        ? (editingBlock.rich_content_id ?? editingBlock.qa_content_id)
        : null;

    const url = editingBlock ? `${base}/${blockId}` : `${base}/`;
    const method = editingBlock ? 'PUT' : 'POST';

    let payload;
    if (editingBlock) {
        // Update: only content-bearing fields (parent never changes on edit)
        payload = { block_type: blockType, content_data: contentData };
    } else if (isQA) {
        payload = {
            qa_id: entityId,
            section,
            block_type: blockType,
            content_data: contentData,
            order_index: orderIndex,
        };
    } else {
        // Teaching parent field derived from level
        const parentField = `${level === 'micro_chunk' ? 'micro_chunk' : level}_id`;
        payload = {
            [parentField]: entityId,
            block_type: blockType,
            content_data: contentData,
            order_index: orderIndex,
        };
    }

    return { url, method, payload };
}